import React from 'react';
import * as S from './styled';
import { X } from 'lucide-react';

export const Modal = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <S.Overlay onClick={handleOverlayClick}>
      <S.ModalContainer>
        <S.Header>
          <S.CloseButton onClick={onClose}>
            <X />
          </S.CloseButton>
          <S.Title>{title}</S.Title>
        </S.Header>
        <S.Content>
          {children}
        </S.Content>
      </S.ModalContainer>
    </S.Overlay>
  );
};
